import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcDinersClub,
  faCcJcb,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";

// Keys are cardType values lowercased with non-letters stripped,
// e.g. "Diners Club" / "DINERS CLUB INTERNATIONAL" -> "dinersclub..."
const brandMatchers = [
  { prefix: "visa", icon: faCcVisa },
  { prefix: "mastercard", icon: faCcMastercard },
  { prefix: "discover", icon: faCcDiscover },
  { prefix: "diners", icon: faCcDinersClub },
  { prefix: "jcb", icon: faCcJcb },
  { prefix: "amex", icon: faCcAmex },
  { prefix: "americanexpress", icon: faCcAmex },
];

export function normalizeCardType(cardType) {
  return String(cardType ?? "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");
}

export function getCardBrandIcon(cardType) {
  const normalized = normalizeCardType(cardType);
  const match = brandMatchers.find(({ prefix }) =>
    normalized.startsWith(prefix)
  );
  return match?.icon ?? faCreditCard;
}
